import { render, staticRenderFns } from "./FuneralDonor.vue?vue&type=template&id=3c595976"
import script from "./FuneralDonor.vue?vue&type=script&lang=js"
export * from "./FuneralDonor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports